module.exports = "/_next/static/images/new-jersey-fb5151f52934807989810160e7405dd5.svg";